<template>
  <div class='SelectProp' v-if="data.active">
    <div class="name-prop">
      {{ data.name }}:
    </div>
    <div class="values">
      <prop-value
      v-for="(v, k) in data.values"
      :key="k"
      :chave="k"
      :data="v"
      :estoque="estoque.filter(e => e.name === v.name)"
      @update:value="newValue => SelectPropProd({ prop: data, value: newValue })"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import PropValue from './PropValue'
export default {
  name: 'SelectProp',
  components: { PropValue },
  props: ['data', 'estoqueVariavel'],
  computed: {
    estoque () {
      let values = []
      for(let key in this.estoqueVariavel) {
        for(let k in this.estoqueVariavel[key].src.values) {
          values.push({ 
            quantidade: this.estoqueVariavel[key].src.quantidade,
            name: this.estoqueVariavel[key].src.values[k].value
          })
        }
      }
      return values
    }
  },
  methods: {
    ...mapActions(['SelectPropProd'])
  }
}
</script>

<style scoped>
.name-prop {
  padding-top: 2%;
  text-align: left;
  font-weight: bold;
}

.values {
  display: flex;
  padding-top: 1%;
}

@media (max-width: 500px) {
  .name-prop {
    text-align: center;
  }
  .values {
    justify-content: center;
  }
}
</style>
